<div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Naloži slike</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="productImage" class="form-label">Naložene slike</label>
        <div class="d-flex align-items-center mb-2">
          <fa-icon class="me-2 text-primary" [icon]="faImage"></fa-icon>
          <input 
            id="uploadImageInput" 
            (change)="onImageUploadChanged($event)" 
            type="file" 
            class="form-control" 
            accept=".png,.jpeg,.jpg,.webp">
        </div>
  
        <!-- Display the number of images selected -->
        <div *ngIf="imageFiles.length > 0" class="mb-3 text-muted">
          <strong>{{ imageFiles.length }} Izbrane slike</strong>
        </div>
  
        <!-- Loop through the array of selected images and display them -->
        <div *ngIf="previewImageSrcs.length > 0" class="d-flex flex-wrap">
          <div 
            *ngFor="let src of previewImageSrcs; let i = index" 
            class="position-relative img-thumbnail me-2 mb-2" 
            style="max-width: 120px;">
            
            <img [src]="src" class="img-fluid rounded" alt="Preview">
      
            <!-- Delete button (X) -->
            <button 
              (click)="removeImage(i)" 
              class="btn btn-danger btn-sm position-absolute top-0 end-0"
              style="border-radius: 50%; width: 24px; height: 24px; padding: 0; line-height: 24px;">
              &times;
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button 
        (click)="addOrgImages()" 
        class="btn btn-primary" 
        [disabled]="imageFiles.length === 0">
        Shrani slike
      </button>
    </div>
  </div>
  